<div class="flex flex-col h-full overflow-hidden">
  @let letsikring = letregisterService.selectedLetsikring();
  @let revision = selectedRevision();
  @if (letregisterService.letsikringDatasource.isLoading()) {
    <app-let-loading-indicator />
  }
  @if (
    letsikring &&
    revision &&
    !letregisterService.letsikringDatasource.isLoading()
  ) {
    <h2>
      Police for {{ letsikring.kunde.navn }} ({{
        letsikring.kunde.cprNummer | cprNummer
      }}) - Reg.nr. {{ letsikring.kunde.pengeinstitut?.regnr }}
    </h2>
    <div class="flex">
      <div class="font-semibold mt-2 pr-8">Revision:</div>
      <p-inputgroup styleClass="!w-[600px]" class="mb-4">
        <p-inputgroup-addon>
          <p-button
            icon="pi pi-angle-double-left"
            severity="secondary"
            (click)="firstRevision()" />
        </p-inputgroup-addon>
        <p-inputgroup-addon>
          <p-button
            icon="pi pi-angle-left"
            severity="secondary"
            (click)="previousRevision()" />
        </p-inputgroup-addon>
        <p-select
          [options]="letsikring.revisioner"
          [(ngModel)]="selectedRevision"
          optionLabel="name"
          placeholder="Vælg revision"
          appendTo="body">
          <ng-template #selectedItem let-selectedOption>
            @if (selectedOption) {
              <div class="flex items-center gap-2">
                <div>
                  <span class="font-semibold">
                    {{ selectedOption.revisionNr }}:
                  </span>
                  {{
                    selectedOption.oprettelsesDato | date: 'dd-MM-yyyy HH:mm:ss'
                  }}
                  - {{ selectedOption.oprettetAf }}
                </div>
              </div>
            }
          </ng-template>
          <ng-template let-option #item>
            <div>
              <span class="numbers">
                <span class="font-semibold"> {{ option.revisionNr }}: </span>
                {{ option.oprettelsesDato | date: 'dd-MM-yyyy HH:mm:ss' }} -
                {{ option.oprettetAf }}
              </span>
            </div>
          </ng-template>
        </p-select>
        <p-inputgroup-addon>
          <p-button
            icon="pi pi-angle-right"
            severity="secondary"
            (click)="nextRevision()" />
        </p-inputgroup-addon>
        <p-inputgroup-addon>
          <p-button
            icon="pi pi-angle-double-right"
            severity="secondary"
            (click)="lastRevision()" />
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>

    <div class="flex gap-4 mb-4">
      @if (!editMode()) {
        <p-button
          label="Vis ændringer"
          (click)="visAendringer()"
          outlined></p-button>
      }

      @if (allowEdit()) {
        @if (!editMode()) {
          <p-button
            label="Rediger nuværende aftale"
            (click)="redigerAftale()"></p-button>
        }
        @if (editMode()) {
          <p-button label="Annuller" (click)="annuller()" outlined></p-button>
          <p-button
            label="Fortryd ændringer"
            (click)="fortryd()"
            outlined></p-button>
          <p-button label="Gem ændringer" (click)="visGem()"></p-button>
        }
      } @else {}
    </div>

    <div class="flex-1 overflow-hidden">
      <p-scroll-panel class="h-full overflow-hidden">
        <app-letsikring-revision
          #letsikringRevisionComponent
          [editMode]="editMode()"
          [revision]="revision"
          [letsikring]="letsikring" />
      </p-scroll-panel>
    </div>
  }
</div>
<p-dialog
  header="Vis ændringer"
  [modal]="true"
  [(visible)]="showDiff"
  [style]="{
    width: '80%',
    maxWidth: '1000px',
    minHeight: '80%',
    maxHeight: '80%',
  }">
  <app-letregister-diff [diff]="comparison()" />
</p-dialog>

<p-dialog
  header="Gem ændringer"
  [modal]="true"
  [(visible)]="showSave"
  [style]="{
    width: '80%',
    maxWidth: '1000px',
    minHeight: '80%',
    maxHeight: '80%',
  }"
  contentStyleClass="flex">
  <div class="flex-1 flex flex-col gap-4 overflow-hidden">
    <div class="font-medium">
      Er du sikker på, at du vil gemme følgende ændringer? Kontroller værdierne
      og tryk på gem for at gemme ændringerne.
    </div>
    <div class="flex-1 overflow-hidden">
      <app-letregister-diff [diff]="comparison()" />
    </div>
    <div class="flex gap-2 items-end">
      <div class="control mb-0 flex-1">
        <label>Ændringskommentar</label>
        <textarea [(ngModel)]="kommentar" pTextarea></textarea>
      </div>
      <p-button label="Annuller" outlined="" (click)="showSave.set(false)" />
      <p-button
        label="Gem ændringer"
        (click)="gemAendringer()"
        [disabled]="kommentar().length < 5" />
    </div>
  </div>
</p-dialog>
